(function () {
  'use strict';
  if (window._jhangoHfV2) return;
  window._jhangoHfV2 = true;

  /* ══ Brand colour map ══ */
  var HEX = {
    'windsor wine':'#78232d','pearl grey':'#AFBAC4','eurasian teal':'#067296',
    'electric blue':'#0063b2','onyx black':'#2c282c','berry blue':'#1B448C',
    'hint mint':'#DDEDE8','murex pink':'#F6C8C3','forest green':'#3E625B',
    'toasted dust':'#B3746D','sunset mustard':'#DAAA00','glacier white':'#E6E6E6',
    'french lavender':'#B2A4D4','asteroid blue':'#B5CEDF','hawk blue':'#223A5E',
    'vintage indigo':'#4A556B','major brown':'#5B5149','violet ice':'#C2ACB1',
    'grape wine':'#4f1727','cloud cream':'#dbdcd2','marled charcoal':'#3f414b',
    'mint green':'#83A393','mocha brown':'#40312f','deep teal':'#18454B',
    'sand dust':'#e1dfcf','english manor':'#a0bbfd','ash grey':'#bebdc0',
    'barely pink':'#e7c8d5','oxford blue':'#4b5489','aqua green':'#cce8ee',
    'desert rose':'#f7bbc0','gravel blue':'#8dadc6','military green':'#909e9c',
    'dark navy':'#252f5c','heather grey':'#a7a5ad','crimson red':'#ac203b',
    'gothic olive':'#75593c','smokey olive':'#515050','dark rose':'#df858f',
    'velvet purple':'#443b67','graphite grey':'#333333'
  };
  function hex(name) {
    var n = (name||'').toLowerCase().trim().replace(/\s+/g,' ');
    if (!n) return null;
    if (HEX[n]) return HEX[n];
    if (/^#?[0-9a-f]{3}([0-9a-f]{3})?$/i.test(n)) return n.charAt(0) === '#' ? n : '#' + n;
    try {
      var s = document.createElement('span');
      s.style.color = '';
      s.style.color = n;
      if (s.style.color) {
        document.body.appendChild(s);
        var rgb = getComputedStyle(s).color;
        document.body.removeChild(s);
        if (rgb && rgb !== 'rgba(0, 0, 0, 0)' && rgb !== 'rgb(0, 0, 0)') return rgb;
        if (rgb === 'rgb(0, 0, 0)' && (n === 'black' || n === '#000' || n === '#000000')) return rgb;
      }
    } catch (e) {}
    return null;
  }

  /* ── Swap product card image with crossfade ── */
  function swapImage(card, imgSrc) {
    if (!imgSrc) return;
    var wrap = card.querySelector('.jhango-hf-image-wrap');
    var img  = wrap && wrap.querySelector('img');
    if (!img) return;
    wrap.classList.add('jhango-hf-img-fading');
    setTimeout(function() {
      img.src = imgSrc;
      /* Also update srcset to same URL so browser doesn't revert */
      if (img.srcset) img.srcset = imgSrc;
      /* Handle <picture><source> elements */
      wrap.querySelectorAll('source').forEach(function(s) {
        s.srcset = imgSrc;
      });
      wrap.classList.remove('jhango-hf-img-fading');
    }, 180);
  }

  function applySwatches(root) {
    (root||document).querySelectorAll('.jhango-hf-swatch[data-colour-name]').forEach(function(el){
      var h = hex(el.dataset.colourName);
      if (h) { el.style.background = h; el.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,.1)'; }
    });
  }

  function initCarousel(wrapEl, trackEl, prevBtn, nextBtn) {
    if (!trackEl || !wrapEl) return;
    function check() {
      var ov = trackEl.scrollWidth > trackEl.clientWidth + 2;
      wrapEl.classList.toggle('has-overflow', ov);
      wrapEl.classList.toggle('fade-left',  trackEl.scrollLeft > 2);
      wrapEl.classList.toggle('fade-right', ov && trackEl.scrollLeft + trackEl.clientWidth < trackEl.scrollWidth - 2);
    }
    check(); requestAnimationFrame(check); setTimeout(check, 300);
    trackEl.addEventListener('scroll', check, {passive:true});
    window.addEventListener('resize', check);
    if (window.ResizeObserver) new ResizeObserver(check).observe(trackEl);
    if (prevBtn) prevBtn.addEventListener('click', function(){ trackEl.scrollBy({left:-110,behavior:'smooth'}); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ trackEl.scrollBy({left: 110,behavior:'smooth'}); });
  }

  function getVariants(card) {
    var el = document.getElementById(card.dataset.variantJsonId);
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch(e) { return []; }
  }

  function optKey(idx) {
    return idx >= 0 && idx <= 2 ? ['option1','option2','option3'][idx] : null;
  }

  function readIdx(ds, key) {
    var raw = ds[key];
    if (raw === undefined || raw === '') return -1;
    var n = parseInt(raw, 10);
    return isNaN(n) ? -1 : n;
  }

  function findVariant(variants, cIdx, cVal, sIdx, sVal) {
    var cKey = optKey(cIdx);
    var sKey = optKey(sIdx);
    var list = variants.filter(function(v){
      var cOk = !cKey || cVal == null || v[cKey] === cVal;
      var sOk = !sKey || sVal == null || v[sKey] === sVal;
      return cOk && sOk;
    });
    return list.find(function(v){return v.available;})||list[0]||null;
  }

  function refreshSizes(card, colourVal) {
    var variants = getVariants(card);
    var cKey = optKey(readIdx(card.dataset, 'colourIdx'));
    var sKey = optKey(readIdx(card.dataset, 'sizeIdx'));
    if (!sKey) return;
    card.querySelectorAll('.jhango-hf-size-btn').forEach(function(btn){
      var match = variants.find(function(v){
        var cOk = !cKey || colourVal == null || v[cKey] === colourVal;
        return cOk && v[sKey] === btn.dataset.sizeValue;
      });
      var avail = match ? match.available : false;
      btn.classList.toggle('jhango-hf-size-btn--oos', !avail);
      btn.disabled = !avail;
      if (!avail) btn.classList.remove('jhango-hf-size-btn--active');
    });
  }

  /* ── Pause/resume parent Swiper autoplay while card UI is open ── */
  function nearestSwiper(card) {
    var el = card && card.closest && card.closest('swiper-slider');
    if (!el || !el.slider || !el.slider.autoplay) return null;
    return el;
  }
  function cardWantsPause(card) {
    var form = card.querySelector('.jhango-hf-form');
    var sgOpen = card.querySelector('.jhango-hf-sg-panel.open');
    return !!(form && form.classList.contains('size-open')) || !!sgOpen;
  }
  function syncCardPause(card) {
    if (!card) return;
    var want = cardWantsPause(card);
    var was = !!card._jhangoHfPaused;
    if (want === was) return;
    card._jhangoHfPaused = want;
    var sw = nearestSwiper(card);
    if (!sw) return;
    sw._jhangoHfPauseCount = (sw._jhangoHfPauseCount || 0) + (want ? 1 : -1);
    if (sw._jhangoHfPauseCount < 0) sw._jhangoHfPauseCount = 0;
    try {
      if (sw._jhangoHfPauseCount > 0) sw.slider.autoplay.stop();
      else sw.slider.autoplay.start();
    } catch (e) {}
  }

  /* set text + keep the label-roll data-label in sync */
  function jhfSetText(el, text){ if (!el) return; el.textContent = text; el.setAttribute('data-label', text); }

  /* On mobile the card CTA reads just "Add"; on desktop the full "Add to Bag". */
  function jhfIsMobile(){ return window.matchMedia('(max-width: 600px)').matches; }
  function jhfAtcLabel(){ return jhfIsMobile() ? 'Add' : 'Add to Bag'; }
  function jhfSyncAtcLabels(root){
    root = root || document;
    var mobile = jhfIsMobile();
    (root.querySelectorAll ? root.querySelectorAll('.jhango-hf-atc-text') : []).forEach(function(el){
      if (!el.dataset.full) el.dataset.full = el.getAttribute('data-label') || el.textContent;
      var short = el.getAttribute('data-short') || el.dataset.full;
      var t = mobile ? short : el.dataset.full;
      el.textContent = t; el.setAttribute('data-label', t);
    });
    (root.querySelectorAll ? root.querySelectorAll('.jhango-hf-size-confirm-text') : []).forEach(function(el){
      var cur = (el.textContent || '').trim();
      if (cur === 'Add to Bag' || cur === 'Add') jhfSetText(el, jhfAtcLabel());
    });
  }
  function jhfOptCount(card){ return card.querySelectorAll('.jhango-hf-opt-row').length; }

  function jhfResolveVariant(card){
    var variants = getVariants(card), sel = card._jhfSel || {}, keys = ['option1','option2','option3'], n = jhfOptCount(card);
    return variants.find(function(v){
      for (var i=0;i<n;i++){ if (sel[i]==null) return false; if (String(v[keys[i]])!==String(sel[i])) return false; }
      return true;
    }) || null;
  }

  function jhfUpdateAvailability(card){
    var variants = getVariants(card), sel = card._jhfSel || {}, keys = ['option1','option2','option3'], n = jhfOptCount(card);
    card.querySelectorAll('.jhango-hf-opt-btn').forEach(function(btn){
      var oi = parseInt(btn.dataset.optIndex,10), val = btn.dataset.optValue;
      var avail = variants.some(function(v){
        if (v.available===false) return false;
        if (String(v[keys[oi]])!==String(val)) return false;
        for (var k=0;k<n;k++){ if (k===oi) continue; if (sel[k]!=null && String(v[keys[k]])!==String(sel[k])) return false; }
        return true;
      });
      btn.classList.toggle('jhango-hf-opt-btn--oos', !avail);
      btn.disabled = !avail;
    });
  }

  function jhfUpdateConfirm(card){
    var confirm = card.querySelector('.jhango-hf-size-confirm');
    if (!confirm) return;
    var sel = card._jhfSel || {}, n = jhfOptCount(card), allSel = true;
    for (var i=0;i<n;i++){ if (sel[i]==null) allSel=false; }
    var match = allSel ? jhfResolveVariant(card) : null;
    if (match && match.available){
      confirm.dataset.variantId = match.id;
      jhfSetText(confirm.querySelector('.jhango-hf-size-confirm-text'), jhfAtcLabel());
      jhfSetText(confirm.querySelector('.jhango-hf-size-confirm-price'), match.price || '');
      confirm.disabled = false; confirm.classList.add('ready');
    } else {
      delete confirm.dataset.variantId;
      jhfSetText(confirm.querySelector('.jhango-hf-size-confirm-text'), allSel ? 'Unavailable' : 'Select options');
      jhfSetText(confirm.querySelector('.jhango-hf-size-confirm-price'), '');
      confirm.disabled = true; confirm.classList.remove('ready');
    }
  }

  function openSizePicker(card){
    var form = card.querySelector('.jhango-hf-form');
    if (form) form.classList.add('size-open');
    card.querySelectorAll('.jhango-hf-sg-panel.open').forEach(function(p){p.classList.remove('open');});
    jhfUpdateAvailability(card);
    jhfUpdateConfirm(card);
    syncCardPause(card);
  }

  function closeSizePicker(card){
    var form = card.querySelector('.jhango-hf-form');
    if (form) form.classList.remove('size-open');
    card._jhfSel = {};
    card.querySelectorAll('.jhango-hf-opt-btn').forEach(function(b){b.classList.remove('jhango-hf-opt-btn--active');});
    var conf = card.querySelector('.jhango-hf-size-confirm');
    if (conf){
      conf.disabled = true; conf.classList.remove('ready','loading');
      jhfSetText(conf.querySelector('.jhango-hf-size-confirm-text'), 'Select options');
      jhfSetText(conf.querySelector('.jhango-hf-size-confirm-price'), '');
      delete conf.dataset.variantId;
    }
    jhfUpdateAvailability(card);
    card.querySelectorAll('.jhango-hf-sg-panel.open').forEach(function(p){p.classList.remove('open');});
    syncCardPause(card);
  }

  function initCard(card) {
    applySwatches(card);
    initCarousel(
      card.querySelector('.jhango-hf-colour-wrap'), card.querySelector('.jhango-hf-colour-picker'),
      card.querySelector('.jhango-hf-colour-arrow--prev'), card.querySelector('.jhango-hf-colour-arrow--next')
    );
    initCarousel(
      card.querySelector('.jhango-hf-size-carousel-wrap'), card.querySelector('.jhango-hf-size-picker'),
      card.querySelector('.jhango-hf-size-arrow--prev'), card.querySelector('.jhango-hf-size-arrow--next')
    );
  }

  /* ── ATC button (type=button) — open the size picker or add. Bound immediately so it
        works on first paint AND on load-more / infinite-scroll injected cards. ── */
  document.addEventListener('click', function(e){
    var atc = e.target.closest('.jhango-hf-atc');
    if (!atc || atc.disabled || atc.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    var form = atc.closest('.jhango-hf-form');
    var card = atc.closest('.jhango-hf-card');
    var sizeInline = form && form.querySelector('.jhango-hf-size-inline');
    if (sizeInline && !form.classList.contains('size-open')) { if (card) openSizePicker(card); return; }
    var vi = form && form.querySelector('.jhango-hf-variant-input');
    doATC(form, vi ? vi.value : '');
  });

  {
    /* ── Option value click (one handler for every option row) ── */
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.jhango-hf-opt-btn');
      if (!btn || btn.disabled || btn.classList.contains('jhango-hf-opt-btn--oos')) return;
      var card = btn.closest('.jhango-hf-card');
      var oi = parseInt(btn.dataset.optIndex,10);
      card._jhfSel = card._jhfSel || {};
      card._jhfSel[oi] = btn.dataset.optValue;
      card.querySelectorAll('.jhango-hf-opt-btn[data-opt-index="'+oi+'"]').forEach(function(b){b.classList.remove('jhango-hf-opt-btn--active');});
      btn.classList.add('jhango-hf-opt-btn--active');
      jhfUpdateAvailability(card);
      jhfUpdateConfirm(card);
    });

    /* ── Back button ── */
    document.addEventListener('click', function(e){
      if (!e.target.closest('.jhango-hf-size-back')) return;
      closeSizePicker(e.target.closest('.jhango-hf-card'));
    });

    /* ── Size Guide toggle ── */
    document.addEventListener('click', function(e){
      var tr = e.target.closest('.jhango-hf-sg-trigger');
      if (tr) {
        var p = document.getElementById(tr.dataset.target);
        if (p) {
          p.classList.toggle('open');
          syncCardPause(tr.closest('.jhango-hf-card'));
        }
        return;
      }
      var cl = e.target.closest('.jhango-hf-sg-close');
      if (cl) {
        var p2 = document.getElementById(cl.dataset.target);
        if (p2) {
          p2.classList.remove('open');
          syncCardPause(cl.closest('.jhango-hf-card'));
        }
      }
    });

    /* ── Safety: never allow a native form submit (would redirect to /cart) ── */
    document.addEventListener('submit', function(e){
      if (e.target.closest('.jhango-hf-form')) e.preventDefault();
    });

    /* ── Confirm button ── */
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.jhango-hf-size-confirm.ready');
      if (!btn||btn.classList.contains('loading')) return;
      var vid = btn.dataset.variantId; if(!vid) return;
      btn.classList.add('loading');
      jhfSetText(btn.querySelector('.jhango-hf-size-confirm-text'), 'Adding…');
      var card=btn.closest('.jhango-hf-card');
      doATC(btn.closest('.jhango-hf-form'), vid);
    });
  }

  /* ── init cards (carousels + wishlist state): now, on ready, and for injected cards ── */
  function jhfInitOne(c){ if (c._jhfInit) return; c._jhfInit = true; try { initCard(c); } catch (e) {} }
  function jhfInitAll(root){
    root = root || document;
    if (root.matches && root.matches('.jhango-hf-card[data-product-id]')) jhfInitOne(root);
    if (root.querySelectorAll) root.querySelectorAll('.jhango-hf-card[data-product-id]').forEach(jhfInitOne);
    try { jhfSyncAtcLabels(root); } catch (e) {}
    try { jhfWishSync(root); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ jhfInitAll(document); });
  else jhfInitAll(document);
  var _jhfLblT;
  window.addEventListener('resize', function(){ clearTimeout(_jhfLblT); _jhfLblT = setTimeout(function(){ jhfSyncAtcLabels(document); }, 150); });
  if (window.MutationObserver) {
    new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; a && j < a.length; j++) { if (a[j].nodeType === 1) jhfInitAll(a[j]); }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ══ Add to Cart — wired to THIS theme's AJAX cart (drawer live, no refresh) ══ */
  function doATC(form, variantId) {
    if (!variantId) return;
    var btn  = form && form.querySelector('.jhango-hf-atc');
    var txt  = btn && btn.querySelector('.jhango-hf-atc-text');
    var orig = txt ? txt.textContent : 'Add to Bag';
    if (btn) btn.disabled = true;
    if (txt) txt.textContent = 'Adding…';

    var cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
      fd.append('sections', cartUI.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    var config = (typeof fetchConfig === 'function')
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { 'Accept': 'application/json' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = fd;
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    fetch(addUrl, config)
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, { source: 'jhango-hf-card', productVariantId: variantId, errors: response.errors || response.description, message: response.message });
          }
          if (txt) txt.textContent = 'Error';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jhango-hf-card', productVariantId: variantId });
        }
        if (cartUI && typeof cartUI.renderContents === 'function') {
          if (typeof cartUI.setActiveElement === 'function') cartUI.setActiveElement(btn || document.activeElement);
          cartUI.renderContents(response); /* re-renders + opens drawer + updates count */
        } else {
          window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
          return;
        }
        if (txt) txt.textContent = 'Added ✓';
      })
      .catch(function (err) { console.error('JHF ATC:', err); if (txt) txt.textContent = 'Error'; })
      .finally(function () { setTimeout(function () { if (btn) btn.disabled = false; if (txt) txt.textContent = orig; }, 2000); });
  }

  /* Wishlist is handled by the unified global controller (jhango-hf-wishlist.js).
     Just re-sync button states when new cards are injected. */
  function jhfWishSync(root) { if (window.jhangoHfWish) window.jhangoHfWish.sync(root); }

})();
